import {
  Avatar,
  Box,
  IconButton,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  useMediaQuery,
} from '@mui/material';
import { Add as AddIcon, Search as SearchIcon } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import _ from 'lodash';
import { FETCH_QUERIES } from '../../actions';
import Container from '../Container';
import { NavLink, SearchBox } from '../controls';

export default function QueryList() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const queryNames = useSelector(
    (state) => state.queries.queryNames,
    _.isEqual
  );
  const [filterText, setFilterText] = useState('');
  const isXs = useMediaQuery((theme) => theme.breakpoints.only('xs'));

  useEffect(() => {
    dispatch({
      type: FETCH_QUERIES,
    });
  }, [dispatch]);

  function renderListItems() {
    const sortedNames = queryNames
      .filter(
        (query) =>
          `${query.title}+${query.identifier}`
            .toLowerCase()
            .indexOf(filterText.toLowerCase()) > -1 || filterText === ''
      )
      .sort((a, b) =>
        `${a.title}+${a.identifier}`.localeCompare(`${b.title}+${b.identifier}`)
      );
    return sortedNames.map((query) => (
      <ListItemButton
        dense
        key={query.identifier}
        to={`/queries/${encodeURIComponent(query.identifier)}`}
        component={NavLink}
        selected={id === query.identifier}
      >
        <ListItemAvatar>
          <Avatar>
            <SearchIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={query.title || query.identifier}
          secondary={query.title ? query.identifier : ''}
          primaryTypographyProps={{ noWrap: true }}
          secondaryTypographyProps={{ noWrap: true }}
        />
      </ListItemButton>
    ));
  }

  function handleFilterChange(event) {
    setFilterText(event.target.value);
  }

  return (
    <Container title="Queries" showBack={isXs && id}>
      <Helmet>
        <title>IR3 | Queries</title>
      </Helmet>
      {(!isXs || !id) && (
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            width: 280,
            [theme.breakpoints.down('sm')]: {
              width: 1,
            },
            height: 1,
          })}
        >
          <Stack
            direction="row"
            sx={{ p: 1, pr: 0.5 }}
            spacing={0.5}
            alignItems="center"
          >
            <SearchBox
              value={filterText}
              onChange={handleFilterChange}
              sx={{ flexGrow: 1 }}
            />
            <IconButton
              title="Add new"
              component={Link}
              to={'/queries/new'}
              size="small"
            >
              <Avatar
                sx={{
                  color: 'secondary.contrastText',
                  backgroundColor: 'secondary.main',
                  width: 24,
                  height: 24,
                  fontSize: 16,
                }}
              >
                <AddIcon fontSize="inherit" />
              </Avatar>
            </IconButton>
          </Stack>
          <List
            dense
            disablePadding
            sx={{
              height: 'calc(100vh - 96px)',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            {renderListItems()}
          </List>
        </Box>
      )}
      {(!isXs || id) && (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            // width: 1,
            height: 1,
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>
      )}
    </Container>
  );
}
